<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;History Report</h5>
  </div>
<div id="mainContent" class="container">
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6">
        <div class="row">  
            <div class="col-md-3">    
           <label class="col-form-label">Type</label>
          </div>
           <div class="col-md-6">
        <select
          class="form-control form-control-xs mt-1"
          [(ngModel)]="selectType"
          (change)="onTypeSelect()"
          >
          <option value="Software">Software</option>
          <option value="Hardware">Hardware</option>
        </select>
      </div>
  </div>
</div> 
<div class="col-sm-6" >
<div class="row">
  <label class="col-sm-3 col-form-label">Branch</label>
  <div class="col-sm-6">
    <select
      class="form-control form-control-xs"
      id="BranchName"
      name="BranchName"
      [(ngModel)]="selectBranch"
      (change)="onBranchSelect()"
    >
      <option value="null">Select Branch</option>
      <option *ngFor="let branchName of branchList" [ngValue]="branchName">
        {{ branchName.name }}
      </option>
    </select>
  </div>
</div>
</div>
</div>
<div class="row mt-2" >
  <div class="col-sm-6" *ngIf="selectType=='Hardware'">
    <div class="row">
      <label class="col-sm-3 col-form-label"
        >Serial Tag</label
      >
      <div class="col-sm-6">
        <mat-form-field appearance="legacy" style="width: 100%">
          <mat-select
            multiple
            [(ngModel)]="selectSerialTag"
            #designateSelectSerialTag="ngModel"
            (selectionChange)="onSelectSerialTag()"
          >
            <mat-option
              (click)="selectAllBranch(designateSelectSerialTag, serialTagList)"
              [value]="0"
              >Select All
            </mat-option>
            <mat-option
              #item
              *ngFor="let serialTag of serialTagList"
              [value]="serialTag"
            >
              {{ serialTag.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

<div class="col-sm-6">
  <div class="row">
    <div class="col-sm-3">
      <label> Date </label>
    </div>

    <div class="col-sm-6">
      <div class="input-group">
        <input
          class="form-control form-control-xs"
          placeholder="dd/mm/yyyy"
          name="fromDate"
          ngbDatepicker
          #fromDate="ngbDatepicker"
          [placement]="'bottom'"
          [maxDate]="currentDate"
          [(ngModel)]="selectDate"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-theme calendar"
            (click)="fromDate.toggle()"
            type="button"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>
</div>

<div class="row mt-2">
  <div class="col-sm-8">
    <div class="row">
    <div class="col-md-3">
      <button
        type="button"
        class="btn btn-sm btn-block btn-outline-theme"
        (click)="onViewReport()">
        View Report
      </button>
</div>
<div class="col-md-3">
  <button
   type="button"
   class="btn btn-sm btn-block btn-outline-theme"
   (click)="onExportToExcelReport()"
   *ngIf="showExcelButton"
  >
  Export To Excel
</button>
</div>
</div>
  </div>
  <div class="col-sm-6"></div>
</div>
</div>
</div>

<div class="container" id="mainContent">
<div class="mt-5" id="contentToConvert" *ngIf="reportList.length>0">
  <div class="row justify-content-center text-center mt-4" style="padding-top: 10px;">
    <span class="bg-theme-title"
      >P G BHAGWAT LLP, Chartered Accountants
    </span>
  </div>
  <div class="row justify-content-center text-center ">
    <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
  </div>
  
   <div class="row col-md-12 mt-2">
  <table  class="table table-bordered table-sm" *ngIf="selectType=='Software'">
     <thead>
         <th>Service Tag</th>
         <th>Name</th>
         <th>Type</th>
         <!-- <th>Employee</th> -->
         <th>Hardware Name</th>
         <th>Hardware Service Tag Number</th>
        <th>Assign Date</th>
        <th>Till Date</th>
     </thead>
    <tbody>
      <ng-container *ngFor="let data of reportList;let dataCount=count;let dataIndex=index;">
        <ng-container *ngFor="let detail of data.assetReportRests;let detailCount=count;let detailIndex=index;">
        <tr *ngIf="detailIndex==0">
        <td [attr.rowspan]="getRowSpanDetails(data)">{{data.assetRest.serviceTagNumber}}</td>
        <td [attr.rowspan]="getRowSpanDetails(data)">{{data.assetRest.assetName}}</td>
        <td [attr.rowspan]="getRowSpanDetails(data)">{{data.assetRest.subType.name}}</td>
        <!-- <td>{{detail.userRest!=null?detail.userRest.firstName:'NA'}} {{detail.userRest!=null?detail.userRest.middleName:''}} {{detail.userRest!=null?detail.userRest.lastName:''}}</td> -->
         <td>{{detail.hardwareRest!=null?detail.hardwareRest.assetName:'Instock'}}</td>
         <td>{{detail.hardwareRest!=null?detail.hardwareRest.serviceTagNumber:'NA'}}</td>
        <td>{{detail.assignDate!=null?detail.assignDate:'NA'}}</td>
        <td>{{detail.tillDate!=null?detail.tillDate:'NA'}}</td>
      </tr>
      <tr *ngIf="detailIndex!=0">
        <!-- <td>{{detail.userRest!=null?detail.userRest.firstName:'NA'}} {{detail.userRest!=null?detail.userRest.middleName:''}} {{detail.userRest!=null?detail.userRest.lastName:''}}</td> -->
        <td>{{detail.hardwareRest!=null?detail.hardwareRest.assetName:'Instock'}}</td>
        <td>{{detail.hardwareRest!=null?detail.hardwareRest.serviceTagNumber:'NA'}}</td>        <td>{{detail.assignDate!=null?detail.assignDate:''}}</td>
        <td>{{detail.tillDate!=null?detail.tillDate:'NA'}}</td>
      </tr>
      </ng-container>
    </ng-container>
    </tbody>
  </table>  
</div> 
<div class="row col-md-12 mt-2">
  <table  class="table table-bordered table-sm" *ngIf="selectType=='Hardware'">
     <thead>
         <th>Service Tag</th>
         <th>Name</th>
         <th>Type</th>
         <th>Make</th>
         <th>Model</th>
         <th>Employee</th>
        <th>Assign Date</th>
        <th>Till Date</th>
     </thead>
    <tbody>
      <ng-container *ngFor="let data of reportList;let dataCount=count;let dataIndex=index;">
        <ng-container *ngFor="let detail of data.assetReportRests;let detailCount=count;let detailIndex=index;">
        <tr *ngIf="detailIndex==0">
        <td [attr.rowspan]="getRowSpanDetails(data)">{{detail.hardwareRest.serviceTagNumber}}</td>
        <td [attr.rowspan]="getRowSpanDetails(data)">{{detail.hardwareRest.assetName}}</td>
        <td [attr.rowspan]="getRowSpanDetails(data)">{{detail.hardwareRest.subType.name}}</td>
        <td [attr.rowspan]="getRowSpanDetails(data)">{{detail.hardwareRest.make!=null?detail.hardwareRest.make:'NA'}}</td>
        <td [attr.rowspan]="getRowSpanDetails(data)">{{detail.hardwareRest.modelNo!=null?detail.hardwareRest.modelNo:'NA'}}</td>
        <td>{{detail.userRest!=null?detail.userRest.firstName:getEmployeeName(detail)}} {{detail.userRest!=null?detail.userRest.middleName:''}} {{detail.userRest!=null?detail.userRest.lastName:''}}</td>
        <td>{{detail.assignDate!=null?detail.assignDate:'NA'}}</td>
        <td>{{detail.tillDate!=null?detail.tillDate:setTillDate(detail)}}</td>
      </tr>
      <tr *ngIf="detailIndex!=0">
        <td>{{detail.userRest!=null?detail.userRest.firstName:getEmployeeName(detail)}} {{detail.userRest!=null?detail.userRest.middleName:''}} {{detail.userRest!=null?detail.userRest.lastName:''}}</td>
        <td>{{detail.assignDate!=null?detail.assignDate:'NA'}}</td>
        <td>{{detail.tillDate!=null?detail.tillDate:setTillDate(detail)}}</td>
      </tr>
      </ng-container>
    </ng-container>
    </tbody>
  </table>  
</div>
</div>
</div>
